import React from 'react';
import PrimaryButton, { PrimaryButtonProps } from 'components/partials/buttons/primary-button';

export type CTABannerProps = {
    headline: string;
    subtext?: string;
    bannerColorClass: string;
    bannerLarger?: boolean;
    button: PrimaryButtonProps;
};

const CTABanner: React.FC<CTABannerProps> = ({ bannerColorClass, bannerLarger, button, headline, subtext }) => {
    return (
        <div className="pattern pattern--cta-banner">
            <div className="container">
                <div className={`cta-banner pattern--has-bgcolor ${bannerColorClass}`}>
                    <h2 className={`${bannerLarger ? 'h1' : 'h5'} headline`}>{headline}</h2>
                    {subtext && <div className="subtext">{subtext}</div>}
                    <PrimaryButton {...button} />
                </div>
            </div>
        </div>
    );
};

export default CTABanner;